import apiRequest from 'lib/apiRequest';
import Avatar from 'entities/Avatar';
import Collection from 'lib/Collection';

// @ts-expect-error ts-migrate(2417) FIXME: Class static side 'typeof GroupAvatars' incorrectl... Remove this comment to see the full error message
export default class GroupAvatars extends Collection<Avatar> {
  parse(response: any) {
    // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'avatar' implicitly has an 'any' type.
    return response.map((avatar) => Avatar.fromJSON(avatar));
  }

  getRandomAvatar() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'at' does not exist on type 'GroupAvatars... Remove this comment to see the full error message
    return this.at(parseInt(Math.random() * this.length, 10));
  }

  // $FlowFixMe
  static fetch(groupName: string | undefined | null = null): Promise<GroupAvatars> {
    const data = {};
    if (groupName) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'q' does not exist on type '{}'.
      data.q = groupName;
    }

    // @ts-expect-error ts-migrate(2322) FIXME: Type 'Promise<GroupAvatars | Collection<Avatar>>' ... Remove this comment to see the full error message
    return apiRequest('/classes/avatars', 'GET', data).then((response) =>
      GroupAvatars.fromJSON(response)
    );
  }
}
